import { Directive, ElementRef, Renderer2, Input, HostListener, NgModule, isDevMode, Injectable, ɵɵdefineInjectable, ɵɵinject, Pipe } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subject, fromEvent } from 'rxjs';
import { takeUntil, map, tap, startWith } from 'rxjs/operators';

/**
 * @fileoverview added by tsickle
 * Generated from: directive/external-link.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/cdk/layout';
class ExternalLinkDirective {
    /**
     * @param {?} element
     * @param {?} renderer
     */
    constructor(element, renderer) {
        this.element = element;
        this.renderer = renderer;
        this.renderer.setAttribute(this.element.nativeElement, 'rel', 'noopener noreferrer');
    }
    /**
     * @return {?}
     */
    openLink() {
        window.open(this.link, '_blank');
    }
}
ExternalLinkDirective.ɵfac = function ExternalLinkDirective_Factory(t) { return new (t || ExternalLinkDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
ExternalLinkDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ExternalLinkDirective, selectors: [["a", "external", ""]], hostBindings: function ExternalLinkDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function ExternalLinkDirective_click_HostBindingHandler() { return ctx.openLink(); });
    } }, inputs: { link: "link" } });
/** @nocollapse */
ExternalLinkDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
ExternalLinkDirective.propDecorators = {
    link: [{ type: Input }],
    openLink: [{ type: HostListener, args: ['click',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ExternalLinkDirective, [{
        type: Directive,
        args: [{
                selector: 'a [external]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { openLink: [{
            type: HostListener,
            args: ['click']
        }], link: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    ExternalLinkDirective.prototype.link;
    /**
     * @type {?}
     * @private
     */
    ExternalLinkDirective.prototype.element;
    /**
     * @type {?}
     * @private
     */
    ExternalLinkDirective.prototype.renderer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: directive/directive.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const directives = [ExternalLinkDirective];
class SharedDirectiveModule {
}
SharedDirectiveModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SharedDirectiveModule });
SharedDirectiveModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SharedDirectiveModule_Factory(t) { return new (t || SharedDirectiveModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SharedDirectiveModule, { declarations: function () { return [ExternalLinkDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ExternalLinkDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SharedDirectiveModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                exports: [...directives],
                declarations: [...directives]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: directive/public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: logger/log.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const PREFIX = '[UI Lib]:';
// Log should only be printed in dev mode.
/** @type {?} */
const _log = (/**
 * @param {...?} args
 * @return {?}
 */
(...args) => {
    if (isDevMode()) {
        console.log(PREFIX, ...args);
    }
});
// Warn should only printed in dev mode.
/** @type {?} */
const _warn = (/**
 * @param {...?} args
 * @return {?}
 */
(...args) => {
    if (isDevMode()) {
        console.warn(PREFIX, ...args);
    }
});
// Error should printed in both dev & prod mode
/** @type {?} */
const _error = (/**
 * @param {...?} args
 * @return {?}
 */
(...args) => {
    /** @type {?} */
    const stack = new Error().stack;
    console.error(PREFIX + '(error): ', ...args, stack);
});

/**
 * @fileoverview added by tsickle
 * Generated from: logger/public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: dom/dom.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const calculateViewportHeight = (/**
 * @return {?}
 */
() => {
    return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
});

/**
 * @fileoverview added by tsickle
 * Generated from: dom/public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: responsive/responsive.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class B2CSharedResponsiveModule {
}
B2CSharedResponsiveModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CSharedResponsiveModule });
B2CSharedResponsiveModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CSharedResponsiveModule_Factory(t) { return new (t || B2CSharedResponsiveModule)(); }, providers: [], imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CSharedResponsiveModule, { imports: function () { return [CommonModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CSharedResponsiveModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                providers: []
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: responsive/responsive.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const Breakpoint = {
    xxl: "xxl",
    xl: "xl",
    lg: "lg",
    md: "md",
    sm: "sm",
    xs: "xs",
};
/** @type {?} */
const breakpointBelow = {
    xs: '(max-width: 480px)',
    sm: '(max-width: 576px)',
    md: '(max-width: 768px)',
    lg: '(max-width: 992px)',
    xl: '(max-width: 1200px)',
    xxl: '(max-width: 1600px)'
};
/** @type {?} */
const breakpointAbove = {
    xs: '(max-width: 575px)',
    sm: '(min-width: 576px)',
    md: '(min-width: 768px)',
    lg: '(min-width: 992px)',
    xl: '(min-width: 1200px)',
    xxl: '(min-width: 1600px)'
};
class ResponsiveService {
    /**
     * @param {?} breakpointObserver
     */
    constructor(breakpointObserver) {
        this.breakpointObserver = breakpointObserver;
        this.MOBILE_WEB_BREAKPOINT = '(max-width: 920px)';
        this.destroy$ = new Subject();
    }
    /**
     * @param {?} breakpoint
     * @return {?}
     */
    once(breakpoint) {
        return this.breakpointObserver.isMatched(breakpoint);
    }
    /**
     * @param {?} breakpoint
     * @return {?}
     */
    observe(breakpoint) {
        return this.breakpointObserver.observe(breakpoint).pipe(takeUntil(this.destroy$));
    }
    /**
     * @param {?} breakpoint
     * @return {?}
     */
    observeBoolean(breakpoint) {
        return this.breakpointObserver.observe(breakpoint).pipe(map((/**
         * @param {?} __0
         * @return {?}
         */
        ({ matches }) => matches)), takeUntil(this.destroy$));
    }
    /**
     * @return {?}
     */
    isMobileWeb() {
        return this.breakpointObserver
            .observe(this.MOBILE_WEB_BREAKPOINT)
            .pipe(map((/**
         * @param {?} bpState
         * @return {?}
         */
        (bpState) => bpState.breakpoints[this.MOBILE_WEB_BREAKPOINT])));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.destroy$.next();
    }
}
ResponsiveService.ɵfac = function ResponsiveService_Factory(t) { return new (t || ResponsiveService)(ɵngcc0.ɵɵinject(ɵngcc1.BreakpointObserver)); };
ResponsiveService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ResponsiveService, factory: ResponsiveService.ɵfac, providedIn: 'root' });
/** @nocollapse */
ResponsiveService.ctorParameters = () => [
    { type: BreakpointObserver }
];
/** @nocollapse */ ResponsiveService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ResponsiveService_Factory() { return new ResponsiveService(ɵɵinject(BreakpointObserver)); }, token: ResponsiveService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ResponsiveService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.BreakpointObserver }]; }, null); })();
if (false) {
    /** @type {?} */
    ResponsiveService.prototype.MOBILE_WEB_BREAKPOINT;
    /**
     * @type {?}
     * @private
     */
    ResponsiveService.prototype.destroy$;
    /**
     * @type {?}
     * @private
     */
    ResponsiveService.prototype.breakpointObserver;
}

/**
 * @fileoverview added by tsickle
 * Generated from: responsive/public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: pipe/filter.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class FilterPipe {
    /**
     * @param {?} items
     * @param {?} searchText
     * @return {?}
     */
    transform(items, searchText) {
        if (!items) {
            return [];
        }
        if (!searchText) {
            return items;
        }
        searchText = searchText.toLowerCase();
        return items.filter((/**
         * @param {?} it
         * @return {?}
         */
        it => {
            return it.label.toLowerCase().includes(searchText);
        }));
    }
}
FilterPipe.ɵfac = function FilterPipe_Factory(t) { return new (t || FilterPipe)(); };
FilterPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "filter", type: FilterPipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FilterPipe, [{
        type: Pipe,
        args: [{
                name: 'filter'
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: pipe/pnl.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PnlPipe {
    /**
     * @param {?} value
     * @param {?} type
     * @return {?}
     */
    transform(value, type) {
        switch (type) {
            case 'text':
                return value > 0 ? 'text-profit' : value < 0 ? 'text-loss' : 'unchanged';
            case 'bg':
                return value > 0 ? 'bg-profit' : value < 0 ? 'bg-loss' : 'bg-unchanged';
            case 'caret':
                return value > 0 ? 'caret-up' : value < 0 ? 'caret-down' : '';
            case 'symbol':
                return value > 0 ? '+' : value < 0 ? '-' : '';
        }
    }
}
PnlPipe.ɵfac = function PnlPipe_Factory(t) { return new (t || PnlPipe)(); };
PnlPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "pnl", type: PnlPipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PnlPipe, [{
        type: Pipe,
        args: [{
                name: 'pnl'
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: pipe/minute.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MinutePipe {
    constructor() { }
    /**
     * @param {?} seconds
     * @return {?}
     */
    transform(seconds) {
        if (seconds === undefined || seconds === null) {
            return seconds;
        }
        /** @type {?} */
        const minutes = Math.floor(seconds / 60);
        /** @type {?} */
        const tailingSeconds = seconds % 60;
        /** @type {?} */
        const secondsString = tailingSeconds.toString();
        /** @type {?} */
        const paddedSeconds = secondsString.length < 2 ? `0${secondsString}` : secondsString;
        return `${minutes}:${paddedSeconds}`;
    }
}
MinutePipe.ɵfac = function MinutePipe_Factory(t) { return new (t || MinutePipe)(); };
MinutePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "minute", type: MinutePipe, pure: true });
/** @nocollapse */
MinutePipe.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MinutePipe, [{
        type: Pipe,
        args: [{ name: 'minute' }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: pipe/pipe.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const pipes = [PnlPipe, FilterPipe, MinutePipe];
class B2CSharedPipeModule {
}
B2CSharedPipeModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CSharedPipeModule });
B2CSharedPipeModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CSharedPipeModule_Factory(t) { return new (t || B2CSharedPipeModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CSharedPipeModule, { declarations: function () { return [PnlPipe,
        FilterPipe,
        MinutePipe]; }, imports: function () { return [CommonModule]; }, exports: function () { return [PnlPipe,
        FilterPipe,
        MinutePipe]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CSharedPipeModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                exports: [...pipes],
                declarations: [...pipes]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: pipe/public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: event/event.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class B2CSharedEventModule {
}
B2CSharedEventModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CSharedEventModule });
B2CSharedEventModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CSharedEventModule_Factory(t) { return new (t || B2CSharedEventModule)(); }, providers: [], imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CSharedEventModule, { imports: function () { return [CommonModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CSharedEventModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                providers: []
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: event/event.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class EventWrapperService {
    constructor() {
        this.scrollSubject$ = new Subject();
        this.scrollEvent$ = this.scrollSubject$.asObservable();
        this.destroy$ = new Subject();
        this.resizeSubject$ = new Subject();
        this.resizeEvent$ = this.resizeSubject$.asObservable();
        fromEvent(document, 'scroll')
            .pipe(takeUntil(this.destroy$), tap((/**
         * @param {?} evt
         * @return {?}
         */
        (evt) => {
            this.scrollSubject$.next(evt);
        })))
            .subscribe();
        fromEvent(window, 'resize')
            .pipe(takeUntil(this.destroy$), tap((/**
         * @param {?} evt
         * @return {?}
         */
        (evt) => {
            this.resizeSubject$.next(evt);
        })))
            .subscribe();
    }
    /**
     * @return {?}
     */
    get scrollEvent() {
        return this.scrollEvent$;
    }
    /**
     * @return {?}
     */
    get resizeEvent() {
        return this.resizeEvent$;
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
        this.destroy$.unsubscribe();
    }
}
EventWrapperService.ɵfac = function EventWrapperService_Factory(t) { return new (t || EventWrapperService)(); };
EventWrapperService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: EventWrapperService, factory: EventWrapperService.ɵfac, providedIn: 'root' });
/** @nocollapse */
EventWrapperService.ctorParameters = () => [];
/** @nocollapse */ EventWrapperService.ngInjectableDef = ɵɵdefineInjectable({ factory: function EventWrapperService_Factory() { return new EventWrapperService(); }, token: EventWrapperService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EventWrapperService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    EventWrapperService.prototype.scrollSubject$;
    /**
     * @type {?}
     * @private
     */
    EventWrapperService.prototype.scrollEvent$;
    /**
     * @type {?}
     * @private
     */
    EventWrapperService.prototype.destroy$;
    /**
     * @type {?}
     * @private
     */
    EventWrapperService.prototype.resizeSubject$;
    /**
     * @type {?}
     * @private
     */
    EventWrapperService.prototype.resizeEvent$;
}

/**
 * @fileoverview added by tsickle
 * Generated from: event/public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: util/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const copyToClipboard = (/**
 * @param {?} str
 * @return {?}
 */
(str) => {
    /** @type {?} */
    const ele = document.createElement('input');
    ele.type = 'text';
    ele.value = str;
    ele.setAttribute('readonly', '');
    ele.setAttribute('aria-hidden', 'true');
    ele.className = 'copy-hidden';
    document.body.appendChild(ele);
    ele.select();
    document.execCommand('copy');
    document.body.removeChild(ele);
});
/** @type {?} */
const encode = (/**
 * @param {?} str
 * @return {?}
 */
(str) => {
    return encodeURI(str);
});

/**
 * @fileoverview added by tsickle
 * Generated from: util/public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: position/position.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class B2CSharedPositionModule {
}
B2CSharedPositionModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CSharedPositionModule });
B2CSharedPositionModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CSharedPositionModule_Factory(t) { return new (t || B2CSharedPositionModule)(); }, imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CSharedPositionModule, { imports: function () { return [CommonModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CSharedPositionModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: logger/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: position/position.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class HeaderPositioningService {
    /**
     * @param {?} renderer
     */
    constructor(renderer) {
        this.renderer = renderer;
        this.lastScrollPos = window.pageYOffset === undefined ? document.documentElement.scrollTop : window.pageYOffset;
        this.position$ = new Subject();
        this.positionObs$ = this.position$.asObservable().pipe(startWith({}));
    }
    /**
     * @return {?}
     */
    get hostElement() {
        return document.getElementById(this.host);
    }
    /**
     * @param {?} id
     * @return {?}
     */
    findHostWrapper(id) {
        /** @type {?} */
        const node = document.getElementById(id);
        this.host = id;
        if (node && node.getBoundingClientRect().height > 0) {
            // host wrapper has been initialised and no longer need to listen for mutation.
            this.emitEvent();
        }
        this.initMutation();
    }
    /**
     * @return {?}
     */
    initScroll() {
        this.scroll$ = fromEvent(document, 'scroll')
            .pipe(startWith(window.pageYOffset), map((/**
         * @return {?}
         */
        () => window.pageYOffset === undefined ? document.documentElement.scrollTop : window.pageYOffset)), tap((/**
         * @param {?} scrollPos
         * @return {?}
         */
        (scrollPos) => {
            /** @type {?} */
            const payload = {
                scrollEvt: true,
                down: scrollPos > this.lastScrollPos
            };
            this.emitEvent(payload);
            this.lastScrollPos = scrollPos <= 0 ? 0 : scrollPos;
        })))
            .subscribe();
    }
    /**
     * @param {?} host
     * @param {?} pusher
     * @return {?}
     */
    calculatePusherHeight(host, pusher) {
        setTimeout((/**
         * @return {?}
         */
        () => {
            if (host && pusher) {
                /** @type {?} */
                const hostHeight = host.nativeElement.getBoundingClientRect().height;
                this.renderer.setStyle(pusher.nativeElement, 'height', `${hostHeight}px`);
            }
        }), 100);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.scroll$) {
            this.scroll$.unsubscribe();
        }
        if (this.position$) {
            this.position$.complete();
            this.position$.unsubscribe();
        }
        if (this.observer) {
            this.observer.disconnect();
        }
    }
    /**
     * @return {?}
     */
    reflow() {
        this.emitEvent();
    }
    /**
     * @private
     * @return {?}
     */
    initMutation() {
        if (!this.host) {
            return;
        }
        /** @type {?} */
        const targetNode = this.hostElement;
        if (!targetNode) {
            _warn(`Cannot find specify wrapper with given ID ${this.host}`);
            return;
        }
        /** @type {?} */
        const config = {
            attributes: true,
            childList: true,
            subtree: true
        };
        /** @type {?} */
        const klass = this;
        /** @type {?} */
        const callback = (/**
         * @param {?} mutationList
         * @return {?}
         */
        function (mutationList) {
            for (const mutation of mutationList) {
                if (mutation.type === 'childList') {
                    klass.emitEvent();
                }
            }
        });
        this.observer = new MutationObserver(callback);
        this.observer.observe(targetNode, config);
    }
    /**
     * @private
     * @param {?=} payload
     * @return {?}
     */
    emitEvent(payload) {
        if (this.hostElement) {
            /** @type {?} */
            const bbox = this.hostElement.getBoundingClientRect();
            // first render snapshot causes bbox to capture wrong value
            /** @type {?} */
            const bboxPos = bbox.y >= document.body.clientHeight ? 0 : bbox.y;
            /** @type {?} */
            const obj = Object.assign({ top: bbox.top, right: bbox.right, bottom: bbox.bottom, left: bbox.left, width: bbox.width, height: bbox.height, scrollPos: window.pageYOffset === undefined
                    ? document.documentElement.scrollTop
                    : window.pageYOffset, isHostAtViewport: bbox.y + bbox.height > 0, topHeight: bboxPos + bbox.height > 0 ? bboxPos + bbox.height : 0 }, payload);
            this.position$.next(obj);
        }
    }
}
HeaderPositioningService.ɵfac = function HeaderPositioningService_Factory(t) { return new (t || HeaderPositioningService)(ɵngcc0.ɵɵinject(ɵngcc0.Renderer2)); };
HeaderPositioningService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: HeaderPositioningService, factory: HeaderPositioningService.ɵfac });
/** @nocollapse */
HeaderPositioningService.ctorParameters = () => [
    { type: Renderer2 }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HeaderPositioningService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Renderer2 }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    HeaderPositioningService.prototype.host;
    /**
     * @type {?}
     * @private
     */
    HeaderPositioningService.prototype.observer;
    /**
     * @type {?}
     * @private
     */
    HeaderPositioningService.prototype.scroll$;
    /**
     * @type {?}
     * @private
     */
    HeaderPositioningService.prototype.lastScrollPos;
    /**
     * @type {?}
     * @private
     */
    HeaderPositioningService.prototype.position$;
    /** @type {?} */
    HeaderPositioningService.prototype.positionObs$;
    /**
     * @type {?}
     * @private
     */
    HeaderPositioningService.prototype.renderer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: position/public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-core.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { B2CSharedEventModule, B2CSharedPipeModule, B2CSharedPositionModule, B2CSharedResponsiveModule, Breakpoint, EventWrapperService, ExternalLinkDirective, HeaderPositioningService, MinutePipe, PREFIX, PnlPipe, ResponsiveService, SharedDirectiveModule, _error, _log, _warn, breakpointAbove, breakpointBelow, calculateViewportHeight, copyToClipboard, encode, FilterPipe as ɵa };


//# sourceMappingURL=b2c-ui-core.js.map